import React from 'react';
import Heading from "@scentregroup/ui/components/heading";
import Paragraph from "@scentregroup/ui/components/paragraph";
import { get } from 'lodash';
import UtilityBox from '../utility-box-v2';
import ExternalLink from '../external-link';
import UtilityBoxItem from '../utility-box-item-v2';
import UtilityBoxOpeningHours from '../utility-box-opening-hours-v2';
import { parseServiceHours } from '../../helpers/parse-opening-hours';
import { conciergeTitle } from '../../helpers/concierge';
import locationLink from '../../helpers/location-link';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const openingHours = (centreTradingHours, storeTradingHours) => {
  if (storeTradingHours) {
    return parseServiceHours(get(storeTradingHours, ['tradingHours']) || [], centreTradingHours.timeZone);
  }
  return parseServiceHours(get(centreTradingHours, ['tradingHours']) || [], centreTradingHours.timeZone);
};
const ServiceUtilityBox = _ref => {
  let {
    centre,
    centreTradingHours,
    storeTradingHours
  } = _ref;
  const address = centre.physicalAddress;
  const address2 = "".concat(centre.suburb, " ").concat(centre.state || '', " ").concat(centre.postcode);
  const externalLocationLink = locationLink(centre.latitude, centre.longitude);
  return /*#__PURE__*/_jsx(UtilityBox, {
    "data-id": "service-utility-box_index_ServiceUtilityBox_UtilityBox",
    children: /*#__PURE__*/_jsxs("div", {
      className: style.utilityInfoWrapper,
      "data-id": "service-utility-box_index_ServiceUtilityBox_UtilityBox_div",
      children: [/*#__PURE__*/_jsx(Heading, {
        type: "small",
        className: style.heading,
        "data-id": "service-utility-box_index_ServiceUtilityBox_div_Heading",
        children: "".concat(centre.title, " ").concat(conciergeTitle(centre.country, centre.slug))
      }, "heading"), /*#__PURE__*/_jsx(UtilityBoxOpeningHours, {
        openingHours: openingHours(centreTradingHours, storeTradingHours),
        centreSlug: centre.slug,
        unlinkedHours: Boolean(storeTradingHours),
        "data-id": "service-utility-box_index_ServiceUtilityBox_div_UtilityBoxOpeningHours"
      }), /*#__PURE__*/_jsx(UtilityBoxItem, {
        icon: "phone",
        classNames: {
          item: style.item
        },
        role: "heading",
        "aria-label": "Phone Number",
        "data-id": "service-utility-box_index_ServiceUtilityBox_div_UtilityBoxItem",
        children: /*#__PURE__*/_jsx(Paragraph, {
          type: "medium",
          "data-id": "service-utility-box_index_ServiceUtilityBox_UtilityBoxItem_Paragraph",
          children: centre.telephoneNumber
        })
      }), address && /*#__PURE__*/_jsxs(UtilityBoxItem, {
        icon: "location-drop-pin",
        classNames: {
          item: style.item
        },
        role: "heading",
        "aria-label": "Store Location",
        "data-id": "service-utility-box_index_ServiceUtilityBox_UtilityBoxItem",
        children: [/*#__PURE__*/_jsx(Paragraph, {
          type: "medium",
          "data-id": "service-utility-box_index_ServiceUtilityBox_UtilityBoxItem_Paragraph",
          children: address
        }), address2 && /*#__PURE__*/_jsx(Paragraph, {
          type: "medium",
          "data-id": "service-utility-box_index_ServiceUtilityBox_Paragraph_8",
          children: address2
        }), externalLocationLink && /*#__PURE__*/_jsx(Paragraph, {
          "data-id": "service-utility-box_index_ServiceUtilityBox_Paragraph_9",
          children: /*#__PURE__*/_jsx(ExternalLink, {
            url: externalLocationLink,
            className: style.mapLink,
            "data-id": "service-utility-box_index_ServiceUtilityBox_Paragraph_ExternalLink",
            children: "See on map"
          })
        })]
      }, "item")]
    })
  });
};
export default ServiceUtilityBox;